export enum DrawingType {
  line = 'line',
  journey = 'journey',
  rect = 'rect',
  circle = 'circle',
  grid_path = 'grid_path',
  cone = 'cone',
  text = 'text',
}
